import React from 'react';
import { Box, Container, Typography, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';

const TermsOfService: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        py: 4,
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url("https://images.unsplash.com/photo-1465146633011-14f8e0781093?q=80&w=2076&auto=format&fit=crop")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'brightness(0.7)',
          zIndex: 0,
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(135deg, rgba(46, 125, 50, 0.85) 0%, rgba(76, 175, 80, 0.75) 50%, rgba(129, 199, 132, 0.65) 100%)',
          zIndex: 1,
        },
      }}
    >
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 2 }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate(-1)}
          sx={{
            mb: 3,
            color: '#ffffff',
            background: 'rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(10px)',
            '&:hover': {
              background: 'rgba(255, 255, 255, 0.3)',
            }
          }}
        >
          Voltar
        </Button>

        <Paper elevation={24} sx={{ p: 4, borderRadius: 3, background: 'rgba(255, 255, 255, 0.98)', backdropFilter: 'blur(20px)' }}>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 700,
              color: '#2E7D32',
              mb: 3,
            }}
          >
            Termos de Uso
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            Última atualização: {new Date().toLocaleDateString('pt-BR')}
          </Typography>

          <Box sx={{ '& > *': { mb: 3 } }}>
            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                1. Aceitação dos Termos
              </Typography>
              <Typography variant="body1" paragraph>
                Bem-vindo ao Semente Diária! Ao acessar e usar nosso aplicativo, você concorda em
                cumprir e estar vinculado a estes Termos de Uso. Se você não concordar com
                qualquer parte destes termos, não deve usar nosso aplicativo.
              </Typography>
              <Typography variant="body1" paragraph>
                Estes termos aplicam-se a todos os usuários do aplicativo, incluindo visitantes,
                usuários cadastrados e administradores.
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                2. Descrição do Serviço
              </Typography>
              <Typography variant="body1" paragraph>
                O Semente Diária é um aplicativo que fornece conteúdo devocional cristão diário,
                incluindo:
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                <ul>
                  <li>Leituras bíblicas diárias com reflexões</li>
                  <li>Vídeos devocionais</li>
                  <li>Acompanhamento de progresso espiritual</li>
                  <li>Possibilidade de marcar favoritos</li>
                  <li>Notificações para lembretes diários</li>
                </ul>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                3. Cadastro e Conta de Usuário
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>3.1. Requisitos:</strong>
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                <ul>
                  <li>Você deve ter pelo menos 13 anos de idade para usar o aplicativo</li>
                  <li>Menores de 18 anos devem ter supervisão de pais ou responsáveis</li>
                  <li>É necessário fornecer informações verdadeiras e precisas</li>
                </ul>
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>3.2. Responsabilidades do Usuário:</strong>
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                <ul>
                  <li>Manter a confidencialidade de sua senha</li>
                  <li>Notificar-nos imediatamente sobre qualquer uso não autorizado</li>
                  <li>Não compartilhar sua conta com terceiros</li>
                  <li>Ser responsável por todas as atividades em sua conta</li>
                </ul>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                4. Uso Aceitável
              </Typography>
              <Typography variant="body1" paragraph>
                Você concorda em NÃO:
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                <ul>
                  <li>Usar o aplicativo para fins ilegais ou não autorizados</li>
                  <li>Violar direitos de propriedade intelectual</li>
                  <li>Transmitir vírus, malware ou código malicioso</li>
                  <li>Tentar obter acesso não autorizado a sistemas ou redes</li>
                  <li>Fazer engenharia reversa do aplicativo</li>
                  <li>Copiar, distribuir ou modificar o conteúdo sem autorização</li>
                  <li>Usar scripts automatizados para coletar dados (scraping)</li>
                  <li>Criar contas falsas ou múltiplas sem autorização</li>
                </ul>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                5. Conteúdo e Propriedade Intelectual
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>5.1. Nosso Conteúdo:</strong>
              </Typography>
              <Typography variant="body1" paragraph>
                Todo o conteúdo do aplicativo (textos, vídeos, imagens, design, código) é
                protegido por direitos autorais e outras leis de propriedade intelectual. Você
                pode usar o conteúdo apenas para uso pessoal e não comercial.
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>5.2. Licença de Uso:</strong>
              </Typography>
              <Typography variant="body1" paragraph>
                Concedemos a você uma licença limitada, não exclusiva, não transferível e
                revogável para acessar e usar o aplicativo para fins pessoais.
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                6. Conteúdo Bíblico
              </Typography>
              <Typography variant="body1" paragraph>
                O conteúdo bíblico apresentado é baseado em traduções reconhecidas da Bíblia
                Sagrada. As reflexões e interpretações são oferecidas para fins devocionais e
                educacionais, e não substituem o estudo pessoal da Bíblia ou orientação pastoral
                profissional.
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                7. Disponibilidade do Serviço
              </Typography>
              <Typography variant="body1" paragraph>
                Embora nos esforcemos para manter o aplicativo disponível 24/7, não garantimos que
                o serviço será ininterrupto ou livre de erros. Podemos:
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                <ul>
                  <li>Realizar manutenções programadas</li>
                  <li>Suspender ou modificar o serviço temporariamente</li>
                  <li>Descontinuar recursos ou funcionalidades</li>
                </ul>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                8. Privacidade
              </Typography>
              <Typography variant="body1" paragraph>
                Seu uso do aplicativo também é regido por nossa{' '}
                <a href="/privacidade" style={{ color: '#4CAF50', textDecoration: 'none' }}>
                  Política de Privacidade
                </a>
                . Por favor, revise-a para entender nossas práticas de coleta e uso de dados.
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                9. Notificações Push
              </Typography>
              <Typography variant="body1" paragraph>
                Ao autorizar notificações push, você concorda em receber lembretes diários e
                alertas sobre novos conteúdos. Você pode desativar as notificações a qualquer
                momento nas configurações do seu dispositivo.
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                10. Isenção de Garantias
              </Typography>
              <Typography variant="body1" paragraph>
                O aplicativo é fornecido "como está" e "conforme disponível", sem garantias de
                qualquer tipo, expressas ou implícitas. Não garantimos que:
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                <ul>
                  <li>O serviço atenderá suas necessidades específicas</li>
                  <li>O serviço será ininterrupto, seguro ou livre de erros</li>
                  <li>Os resultados obtidos serão precisos ou confiáveis</li>
                  <li>Defeitos no aplicativo serão corrigidos</li>
                </ul>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                11. Limitação de Responsabilidade
              </Typography>
              <Typography variant="body1" paragraph>
                Na extensão máxima permitida por lei, não seremos responsáveis por quaisquer
                danos diretos, indiretos, incidentais, especiais, consequenciais ou punitivos
                resultantes de:
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                <ul>
                  <li>Uso ou incapacidade de usar o aplicativo</li>
                  <li>Acesso não autorizado aos seus dados</li>
                  <li>Erros ou omissões no conteúdo</li>
                  <li>Interrupção ou cessação do serviço</li>
                </ul>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                12. Indenização
              </Typography>
              <Typography variant="body1" paragraph>
                Você concorda em indenizar e isentar o Semente Diária, seus desenvolvedores e
                parceiros de quaisquer reivindicações, perdas, responsabilidades, danos, custos e
                despesas (incluindo honorários advocatícios) resultantes de:
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                <ul>
                  <li>Seu uso do aplicativo</li>
                  <li>Violação destes Termos de Uso</li>
                  <li>Violação de direitos de terceiros</li>
                </ul>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                13. Modificações dos Termos
              </Typography>
              <Typography variant="body1" paragraph>
                Reservamos o direito de modificar estes Termos de Uso a qualquer momento. As
                alterações entrarão em vigor imediatamente após a publicação. É sua
                responsabilidade revisar periodicamente estes termos. O uso contínuo do aplicativo
                após as mudanças constitui sua aceitação dos novos termos.
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                14. Rescisão
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>14.1. Por Você:</strong> Você pode encerrar sua conta a qualquer momento
                através das configurações do aplicativo ou entrando em contato conosco.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>14.2. Por Nós:</strong> Podemos suspender ou encerrar sua conta
                imediatamente, sem aviso prévio, se você violar estes Termos de Uso.
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                15. Lei Aplicável e Jurisdição
              </Typography>
              <Typography variant="body1" paragraph>
                Estes Termos de Uso serão regidos e interpretados de acordo com as leis do Brasil.
                Qualquer disputa relacionada a estes termos será submetida à jurisdição exclusiva
                dos tribunais brasileiros.
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                16. Contato
              </Typography>
              <Typography variant="body1" paragraph>
                Para dúvidas, sugestões ou questões relacionadas a estes Termos de Uso, entre em
                contato:
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                <strong>E-mail:</strong> contato@sementediaria.com.br
                <br />
                <strong>Suporte:</strong> suporte@sementediaria.com.br
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                17. Disposições Gerais
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>17.1. Acordo Integral:</strong> Estes Termos de Uso, juntamente com a
                Política de Privacidade, constituem o acordo integral entre você e o Semente
                Diária.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>17.2. Divisibilidade:</strong> Se qualquer disposição destes termos for
                considerada inválida ou inexequível, as demais disposições permanecerão em pleno
                vigor.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>17.3. Renúncia:</strong> A falha em exercer qualquer direito sob estes
                termos não constituirá uma renúncia a esse direito.
              </Typography>
            </Box>
          </Box>

          <Box sx={{ mt: 4, p: 3, bgcolor: '#e8f5e9', borderRadius: 2 }}>
            <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
              Ao utilizar o Semente Diária, você reconhece que leu, compreendeu e concordou com
              estes Termos de Uso.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsOfService;
